export const isSupportedNFT = async (
  metaspaceNFTMarketplaceContract,
  nftContract
) => {
  return await metaspaceNFTMarketplaceContract.isSupportedNFT(nftContract);
};

export const updateSupportedNFT = async (
  metaspaceNFTMarketplaceContract,
  nftContract,
  isSupport
) => {
  return await metaspaceNFTMarketplaceContract.updateSupportedNFT(
    nftContract,
    isSupport
  );
};
export const updateNFTSupportForStaking = async (
  stakingContract,
  nftContractAddress,
  isSupport
) => {
  return await stakingContract.updateNFTSupport(nftContractAddress, isSupport);
};
export const listNFT = async (
  metaspaceNFTMarketplaceContract,
  address,
  tokenId,
  currency,
  price,
  auction
) => {
  return await metaspaceNFTMarketplaceContract.listNFT(
    address,
    tokenId,
    currency,
    price,
    auction
  );
};

export const listInBatch = async (
  metaspaceNFTMarketplaceContract,
  address,
  tokenId,
  currency,
  price,
  auction
) => {
  return await metaspaceNFTMarketplaceContract.listInBatch(
    address,
    tokenId,
    currency,
    price,
    auction
  );
};

export const ownerOf = async (nftContract, tokenId) => {
  return await nftContract.ownerOf(tokenId);
};

export const isApprovedForAll = async (
  nftContract,
  userAddress,
  nftMarkteplaceAddress
) => {
  return await nftContract.isApprovedForAll(userAddress, nftMarkteplaceAddress);
};

export const setApprovalForAll = async (nftContract, nftMarkteplaceAddress) => {
  return await nftContract.setApprovalForAll(nftMarkteplaceAddress, true);
};

export const checkAllowance = async (
  lordTokenContract,
  userAddress,
  spender
) => {
  return await lordTokenContract.allowance(userAddress, spender);
};
